// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__uyyG4","Light":"Tooltip_Light__Rwntr","Dark":"Tooltip_Dark__AFJP4"};